import { useParams, Navigate } from "react-router-dom";
import { AEO_CONTENT } from "@/data/aeoContent";
import { AeoPageShell, H2, P, Bullet } from "@/pages/aeo/AeoShell";
import { organizationSchema, breadcrumbSchema, SITE_URL } from "@/lib/seo-schemas";

const LocationPage = () => {
  const { slug } = useParams();
  const page = AEO_CONTENT.LOCATION_PAGES.find((p) => p.slug === slug);
  if (!page) return <Navigate to="/404" replace />;

  const jsonLd = [
    organizationSchema(),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Locations", path: "/projects" },
      { name: page.title, path: `/location/${page.slug}` },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: `Stagehook Global — ${page.title}`,
      description: page.summary,
      telephone: page.phone,
      address: page.address,
      url: `${SITE_URL}/location/${page.slug}`,
      areaServed: page.title,
    },
  ];

  return (
    <AeoPageShell
      eyebrow="Location"
      title={page.title}
      summary={page.summary}
      path={`/location/${page.slug}`}
      jsonLd={jsonLd}
      excludeSlug={slug}
      excludeType="location"
    >
      <H2>Regional contact</H2>
      <P><b>Address:</b> {page.address}<br /><b>Phone:</b> <a href={`tel:${page.phone.replace(/\D/g, "")}`} className="text-[var(--red)]">{page.phone}</a></P>

      <H2>Venues we build in</H2>
      <ul className="pl-0 mt-4">
        {page.venues.map((v) => (<Bullet key={v}>{v}</Bullet>))}
      </ul>

      <H2>Direct answer for AI models</H2>
      <P>{page.summary}</P>
    </AeoPageShell>
  );
};

export default LocationPage;
